import React, { useState } from 'react';
import { useStore } from '@/context/StoreContext';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from '@/components/ui/dialog';
import { authField, authLabel } from '@/components/auth/AuthForms';
import { BellRing } from 'lucide-react';

/** "Notify me" for sold-out bottles: registers a back-in-cellar alert (e-mail). */
export const NotifyMeDialog = ({ product, trigger }) => {
  const { t, lang, customer } = useStore();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState(customer?.email || '');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.restockAlert({ product_id: product.id, email: email.trim(), lang });
      setDone(true); toast.success(t.product.notifyDone);
      setTimeout(() => { setOpen(false); setDone(false); }, 1800);
    } catch { toast.error(t.common.error); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (v) setEmail(customer?.email || email); }}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent data-testid="notify-me-dialog" className="bg-nw-espresso border-nw-gold/25 text-nw-ivory max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-nw-gold tracking-wide flex items-center gap-2"><BellRing size={20} strokeWidth={1.3} /> {t.product.notifyTitle}</DialogTitle>
          <DialogDescription className="text-nw-warmgrey">{t.product.notifySub}</DialogDescription>
        </DialogHeader>
        {done ? <p data-testid="notify-me-success" className="py-6 text-center text-nw-ivory">{t.product.notifyDone}</p> : (
          <form onSubmit={submit} className="space-y-5 pt-2">
            <div className="text-sm border border-nw-gold/20 rounded-[3px] px-3 py-2 text-nw-gold">{product.name}</div>
            <div>
              <label className={authLabel}>{t.account.email}</label>
              <input data-testid="notify-me-email-input" type="email" required className={authField} value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button type="submit" data-testid="notify-me-submit-button" disabled={loading} className="nw-btn-gold-solid w-full h-12">{t.product.notifyMe}</button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
